import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import DateRangeOutlined from '@mui/icons-material/DateRangeOutlined';
import { FitbitParticipantAvailability, FitbitReadParticipant } from '../../../services/fitbitCollectionDataService';
import { dateLabel as storedDateLabel } from '../../../utils/dateRanges';
export { storedDateLabel };
export function availabilityLabel(availability?: FitbitParticipantAvailability | null, status?: FitbitReadParticipant['availabilityStatus']) {
  if (status === 'checking') return 'Checking stored dates…';
  if (status === 'error') return 'Could not load stored dates. Refresh to retry.';
  if (!availability) return 'Stored dates not checked yet';
  if (!availability.range) return 'No stored data yet';
  return `Data available from ${storedDateLabel(availability.range.startDate)} to ${storedDateLabel(availability.range.endDate)}`;
}
export default function StoredDateRange({ availability }: { availability?: FitbitParticipantAvailability | null }) {
  return <Stack direction="row" gap={1} alignItems="center" sx={{ flex: 1, minWidth: 0, px: 1.25, py: 1,
    bgcolor: '#f5f7fa', borderRadius: '10px' }}>
    <DateRangeOutlined sx={{ color: 'text.secondary', fontSize: 18 }} />
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="caption" sx={{ fontWeight: 500 }}>{availabilityLabel(availability)}</Typography>
    </Box>
  </Stack>;
}
